import { useState, useEffect, useRef } from 'react';
import Person from '../assets/images/business-woman.png';
import SecImg from '../assets/images/cafe.png';
import FirstImg from '../assets/images/retail.png';

function Testimonial() {

  const testimonialData = [
    {
      id: 1,
      type: "testimonial",
      height: "h-72",
      image: FirstImg,
      quote: "VernPOS is a game changer!",
      description: "It has streamlined our operations and improved customer satisfaction.",
      author: "Balqis",
      role: "Business Owner"
    },
    {
      id: 2,
      type: "testimonial",
      height: "h-72",
      image: SecImg,
      quote: "VernPOS are the best!",
      description: "Everything is so easy to use and the support is amazing.",
      author: "Hazim",
      role: "Business Owner"
    },
    {
      id: 3,
      type: "testimonial",
      height: "h-72",
      image: Person,
      quote: "VernPOS transformed our operations overnight!",
      description: "We've reduced wait times and improved order accuracy. Our customers love it!",
      author: "Sarah",
      role: "Café Owner"
    }
  ];

  var title = "Unlock the Full Potential of Your Business";
  var subtitle = "Discover how VernPOS can drive efficiency, reduce costs, and grow your bottom line.";
  const testimonials = testimonialData;

  const cardsContainerRef = useRef(null);
  const cardRefs = useRef([]);
  const [cardHeight, setCardHeight] = useState(0);

  // Function for smooth value interpolation
  const valueAtPercentage = ({ from, to, percentage }) => {
    return from + (to - from) * percentage;
  };

  useEffect(() => {
    const cardsContainer = cardsContainerRef.current;
    const cards = cardRefs.current.filter(Boolean);

    if (!cardsContainer || cards.length === 0) return;

    // Set initial card height
    setCardHeight(cards[0].clientHeight);

    // Setup intersection observers for each card
    const observers = [];

    cards.forEach((card, index) => {
      // Set padding top
      const offsetTop = 20 + index * 20;
      card.style.paddingTop = `${offsetTop}px`;

      if (index === cards.length - 1) return;

      const toScale = 1 - (cards.length - 1 - index) * 0.05;
      const nextCard = cards[index + 1];
      const cardInner = card.querySelector('.card__inner');

      // Create IntersectionObserver for scroll effects
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            const boundingRect = entry.boundingClientRect;
            const targetRect = entry.target.getBoundingClientRect();

            // Calculate scroll percentage
            const start = -targetRect.height;
            const end = window.innerHeight;
            const current = boundingRect.top;
            const percentageY = Math.max(0, Math.min(1, 1 - (current - start) / (end - start)));

            // Apply scale and brightness transformations
            cardInner.style.transform = `scale(${valueAtPercentage({
              from: 1,
              to: toScale,
              percentage: percentageY
            })})`;

            cardInner.style.filter = `brightness(${valueAtPercentage({
              from: 1,
              to: 0.9,
              percentage: percentageY
            })})`;
          });
        },
        {
          threshold: Array.from({ length: 41 }, (_, i) => i * 0.025), // Create many threshold points for smoother animation
          rootMargin: `${offsetTop}px 0px ${window.innerHeight - card.clientHeight}px 0px`
        }
      );

      observer.observe(nextCard);
      observers.push(observer);
    });

    // Cleanup
    return () => {
      observers.forEach(observer => observer.disconnect());
    };
  }, []);

  // Function to render different card types based on data
  const renderCard = (card) => {
    if (!card) return null;

    switch (card.type) {
      case 'background':
      case 'middle':
        return (
          <div
            className="card__inner will-change-transform rounded-3xl shadow-lg origin-top"
            style={{
              backgroundColor: card.color || '#f0f0f0',
              height: card.height === 'h-72' ? '18rem' : card.height
            }}
          />
        );

      case 'testimonial':
        return (
          <div
            className="card__inner will-change-transform rounded-3xl overflow-hidden shadow-xl origin-top"
            style={{
              height: card.height === 'h-96' ? '24rem' : card.height || '24rem',
            }}
          >
            <div className="relative h-full w-full">
              {/* ✅ Background Image */}
              <div
                className="absolute inset-0 bg-cover bg-top bg-no-repeat"
                style={{ backgroundImage: `url(${card.image})` }}
              />

              {/* ✅ Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-r from-black to-transparent opacity-70" />

              {/* ✅ Text Content */}
              <div className="relative h-full text-white p-8 md:p-12 flex flex-col justify-center z-10 w-64 md:w-1/2 lg:w-1/2">
                <h2 className="text-2xl md:text-4xl font-bold mb-4">{card.quote}</h2>
                <p className="text-base md:text-xl mb-4">{card.description}</p>
                <p className="text-sm md:text-lg font-semibold">
                  – {card.author}, {card.role}
                </p>
              </div>

            </div>
          </div>
        );

      default:
        return null;
    }
  };


  return (
    <div className="bg-white min-h-screen font-sans p-6">
      {/* Header */}
      <div className="text-center max-w-4xl mx-auto pt-20 px-4 mb-12">
        <h1 className="text-5xl font-bold mb-6">{title}</h1>
        <p className="text-xl text-center">{subtitle}</p>
      </div>

      <div className="space--small h-20"></div>

      {/* Cards Container */}
      <div
        ref={cardsContainerRef}
        className="w-full max-w-4xl mx-auto grid lg:gap-y-0"
        style={{
          gridTemplateRows: `repeat(${testimonials.length}, ${cardHeight || 'auto'})`
        }}
      >
        {testimonials.map((card, index) => (
          <div
            key={card.id}
            className="card sticky top-0"
            data-index={index}
            ref={el => cardRefs.current[index] = el}
          >
            {renderCard(card)}
          </div>
        ))}
      </div>

      <div className="space h-[4vh]"></div>
    </div>
  );
}

export default Testimonial;
